import axiosInstance from '../lib/axios';
import type { BackgroundThemeId } from '../types';

export interface HomeAppearance {
  backgroundTheme: BackgroundThemeId;
  backgroundThemeIntensity: number;
}

interface HomeAppearanceResponse {
  success: boolean;
  data: HomeAppearance;
}

export async function getHomeAppearance(): Promise<HomeAppearance> {
  const response = await axiosInstance.get<HomeAppearanceResponse>('/v1/public/home-appearance', {
    skipAuthRefresh: true,
    skipErrorToast: true,
  });
  return response.data.data;
}
